module.exports = __webpack_public_path__ + "static/media/landram.b5a3dba8.png";